module.exports = __webpack_public_path__ + "img/FI.a5471749.svg";